import React from 'react';
import webapi from '../../../api/webapi';
import Modal from 'react-bootstrap/Modal'
import '../../css/keyboard.min.css';
import '../../css/menu.css';
import '../../css/modal1.css';
import '../../css/style.css';

class RelativeResultList extends React.Component {
    state = { results : [] }
    state = { word : '' }
    state = { modalshow: false};
    state = { modalHeader : '' }
    state = { modalText : '' }
    state = { prevwordnext: ''}

    constructor(props) {
        super(props);
        this.state = { results: this.props.results };
        //console.log(this.props.results);
        this.state = { modalshow: false};
        
    }

   
    showModal = async (event,value) => {
        event.preventDefault();
        
        
        //console.log("value:",value);
        //console.log("id:",this.state.modalshow);
        if (!this.state.modalshow)
        {
            //console.log("url:",'sentence/detail/'+event.target.id);
            const responseText= await webapi.get('sentence/detail/'+event.target.id+'/'+value);
            this.setState({modalText:responseText.data});
            //alert(responseText.data);
            this.setState({modalHeader: 
                value
            });
            //console.log("responseText:",responseText);
            this.setState({modalshow: true});
            //alert(this.state.modalText);
        }
        else
        {
            this.setState({modalshow: false});
            this.setState({modalText: '' });
        }
        
        //console.log("modalText:",this.state.modalText);
        //this.setState({modalshow: true});
    };

    CloseModal = event => {
        event.preventDefault();
        this.setState({modalshow: false});
    }

    

    render() {
        if (this.props.results) {
            if (this.props.results.length>0) {
                return (
                    <div>
                        {
                            this.props.results.map((results,i) =>{
                                return  (
                                    <div key={i} className="ui segment" dir="ltr">
                                        <form className="ui form">
                                            <div className="ui field" style={{display:'block',width:'100%',float:'left'}}>
                                                {
                                                    //TextCode,Transcription,ChapterCode,ChapterTitle,Chapter,Sequence,BookCode
                                                    // this.setState(prevwordnext, ((results.PrevWord3!=='')?results.PrevWord3+' ':'')+
                                                    //                             ((results.PrevWord2!=='')?results.PrevWord2+' ':'')+
                                                    //                             ((results.PrevWord1!=='')?results.PrevWord1+' ':'')+
                                                    //                             ((results.Word!=='')?results.Word:'')+
                                                    //                             ((results.NextWord1!=='')?' '+results.NextWord1:'')+
                                                    //                             ((results.NextWord2!=='')?' '+results.NextWord2:'')+
                                                    //                             ((results.NextWord3!=='')?' '+results.NextWord3:'')
                                                    // )
                                                }   

                                                {
                                                    (results.PrevWord3!=='')
                                                    ?
                                                    <font size="4.5" face=""> {results.PrevWord3} </font>
                                                    :
                                                    null
                                                }
                                                {
                                                    (results.PrevWord2!=='')
                                                    ?
                                                    <font size="4.5" face=""> {results.PrevWord2} </font>
                                                    :
                                                    null
                                                }
                                                {
                                                    (results.PrevWord1!=='')
                                                    ?
                                                    <font size="4.5" face=""> {results.PrevWord1} </font>
                                                    :
                                                    null
                                                }

                                                <font size="4.5" face=""> {results.Word} </font>

                                                {
                                                    (results.NextWord1!=='')
                                                    ?
                                                    <font size="4.5" face=""> {results.NextWord1} </font>
                                                    :
                                                    null
                                                }
                                                {
                                                    (results.NextWord2!=='')
                                                    ?
                                                    <font size="4.5" face=""> {results.NextWord2} </font>
                                                    :
                                                    null
                                                }
                                                {
                                                    (results.NextWord3!=='')
                                                    ?
                                                    <font size="4.5" face=""> {results.NextWord3} </font>
                                                    :
                                                    null
                                                }
                                                
                                                <font size="4.5" face="">| تعداد : {results.CCount} </font>
                                                <hr />
                                                {
                                                    results.Books.map((bookObject ,j) => (
                                                        <div key={j} style={{float:'left',width:'100%',margin:'0px',marginBottom:'-15px'}}>
                                                            <br />
                                                            <div title={bookObject.BookTitle} style={{cursor:'pointer',float:'left'}}><font size="3">{bookObject.Book} :  </font></div>
                                                            {
                                                            // <h6>ChapterCode:{chapterObject.ChapterCode}</h6>
                                                            // <h6>ChapterTitle:{chapterObject.ChapterTitle}</h6>
                                                            // <h6>BookCode:{chapterObject.BookCode}</h6>
                                                            }
                                                            {
                                                                bookObject.Texts.map((textObject,k) => (
                                                                    // (k===0) ?
                                                                    // (<a href="/#" key={this.state.prevwordnext} id={textObject.TextCode} onClick={event => {this.showModal(event)}} style={{cursor: 'pointer'}}>{textObject.Sequence}</a>)
                                                                    // :
                                                                    (<a href="/#"   key={textObject.TextCode}
                                                                                    value={
                                                                                        ((results.PrevWord3!=='')?results.PrevWord3+' ':'')+
                                                                                        ((results.PrevWord2!=='')?results.PrevWord2+' ':'')+
                                                                                        ((results.PrevWord1!=='')?results.PrevWord1+' ':'')+
                                                                                        ((results.Word!=='')?results.Word:'')+
                                                                                        ((results.NextWord1!=='')?' '+results.NextWord1:'')+
                                                                                        ((results.NextWord2!=='')?' '+results.NextWord2:'')+
                                                                                        ((results.NextWord3!=='')?' '+results.NextWord3:'')
                                                                                    } 
                                                                                    id={textObject.TextCode} 
                                                                                    onClick={event =>   {this.showModal(event,
                                                                                                                                ((results.PrevWord3!=='')?results.PrevWord3+' ':'')+
                                                                                                                                ((results.PrevWord2!=='')?results.PrevWord2+' ':'')+
                                                                                                                                ((results.PrevWord1!=='')?results.PrevWord1+' ':'')+
                                                                                                                                ((results.Word!=='')?results.Word:'')+
                                                                                                                                ((results.NextWord1!=='')?' '+results.NextWord1:'')+
                                                                                                                                ((results.NextWord2!=='')?' '+results.NextWord2:'')+
                                                                                                                                ((results.NextWord3!=='')?' '+results.NextWord3:'')
                                                                                                                        )
                                                                                                        }
                                                                                            } 
                                                                                    style={{cursor: 'pointer'}}
                                                                    > 
                                                                        {textObject.Sequence}
                                                                    </a>)
                                                                ))
                                                            }
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </form>   
                                    </div>
                                )  
                            })
                        }
                        {
                            (this.state.modalText) 
                            ?
                            (
                                <Modal
                                    show={this.state.modalshow}
                                    onHide={() => this.setState({modalshow: false})}
                                    dialogClassName="modal-90w"
                                    aria-labelledby="modal-styling-title"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title id="modal-styling-title">
                                            
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Transcription:</div>
                                                    </td>
                                                    <td>
                                                        <div className="ltrData">{this.state.modalText.Transcription}</div>
                                                        </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Transliteration:</div>
                                                    </td>
                                                    <td>
                                                        <div className="ltrData">{this.state.modalText.Transliteration}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Translation:</div>
                                                    </td>    
                                                    <td>    
                                                        <div className="ltrDataFa">{this.state.modalText.Translation}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Category:</div>
                                                    </td>    
                                                    <td>   
                                                        <div className="ltrDataFa">{this.state.modalText.Category}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="Caption">Lemma:</div>
                                                    </td>    
                                                    <td>    
                                                        <div className="ltrData">{this.state.modalText.Lemma}</div>
                                                    </td>
                                                </tr>
                                                <tr> 
                                                <td>
                                                        <div className="Caption">Reference1:</div>
                                                    </td>    
                                                    <td>    
                                                        <div className="ltrData">{this.state.modalText.Reference1}</div>
                                                    </td>
                                                </tr>
                                                <tr>   
                                                <td>
                                                        <div className="Caption">Reference2:</div>
                                                    </td>    
                                                    <td>     
                                                        <div className="ltrData">{this.state.modalText.Reference2}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div className="ltrData">
                                            {
                                                this.state.modalText.Paragraph.map((ParagraphItem,k) =>{
                                                    return(
                                                        (ParagraphItem.Text===this.state.modalHeader)
                                                        ?
                                                            (<span className='HighLight' key={k}>{ParagraphItem.Text}</span>)
                                                        :
                                                            (ParagraphItem.Text)
                                                    )
                                                })
                                            }
                                        </div>
                                        <br />
                                        <div className="rtlDataFa">{this.state.modalText.ParagraphTranslation}</div>
                                    </Modal.Body>
                                </Modal>
                            )
                            :
                            null
                        }
                    </div>
                )
            }
            else
            {
                return (<div>{this.props.pageData.length!==0 && this.props.pageData[0].F29903!== undefined?this.props.pageData[0].F29903:29903/*موردی یافت نشد*/}</div>)
            }
        }
        else
        {
            return (<div></div>)
        } 
    }
}


export default RelativeResultList;